import axios from "axios";
import { BASE_URL } from "./graphql/endpoint";
import { isTokenExpired, CustomLocalStorage, TOKEN_KEYS } from "../utils/customStorage";
import { refreshAccessToken as sharedRefresh } from "./auth/refresh";

const FormDataRestClient = axios.create({
  baseURL: BASE_URL,
});

const JsonRestClient = axios.create({
  baseURL: BASE_URL,
});


const refreshAccessToken = sharedRefresh;

FormDataRestClient.interceptors.request.use(async function (config) {
    let token = await CustomLocalStorage.getItem(TOKEN_KEYS.ACCESS);
    if (!token || isTokenExpired(token)) {
      token = await refreshAccessToken();
    }
    config.headers = { 
      ...config.headers, 
      'Content-Type': 'multipart/form-data',
    };
    if (token) config.headers['Authorization'] = `JWT ${token}`;
    return config;
  }, function (error) {
    return Promise.reject(error);
  }
);

JsonRestClient.interceptors.request.use(async function (config) {
  let token = await CustomLocalStorage.getItem(TOKEN_KEYS.ACCESS);
  if (!token || isTokenExpired(token)) {
    token = await refreshAccessToken();
  }
  config.headers = { ...config.headers, 'content-type': 'application/json' };
  if (token) config.headers['Authorization'] = `JWT ${token}`;
  return config;
  }, function (error) {
  return Promise.reject(error);
  }
);

const responseRefreshHandler = async (error, client) => {
  const originalRequest = error.config;
  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    const newToken = await refreshAccessToken();
    if (newToken) {
      originalRequest.headers = {
        ...originalRequest.headers,
        Authorization: `JWT ${newToken}`,
      };
      return client(originalRequest);
    }
  }
  return Promise.reject(error);
}

FormDataRestClient.interceptors.response.use((r)=>r, (e)=>responseRefreshHandler(e, FormDataRestClient));
JsonRestClient.interceptors.response.use((r)=>r, (e)=>responseRefreshHandler(e, JsonRestClient));

export {
  FormDataRestClient,
  JsonRestClient
}